<template>
  <v-app>
    <script type="application/javascript" defer src="//katacoda.com/embed.js"></script>
    <div
      v-show="display != false"
      class="my-2"
      :data-katacoda-id="id"
      data-katacoda-ui="panel"
      data-katacoda-port="8080"
      data-katacoda-color="ff8c00">
    </div>
      
  </v-app>
</template>

<script>

export default {
  props: ['id','display'],
  name: 'LiveVE',
  data: () => ({}),
  mounted(){
  }
}
</script>
